// jQuery
jQuery(function ($) {
  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $('.totop');

  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 300, 'swing');
    return false;
  });

});

// JavaScript
//
// ハンバーガーメニュー用のJS
//
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header");
  const toggleButton = document.querySelector(".hamburger");
  const navMenu = document.querySelector("#nav-menu");
  const menuLinks = header.querySelectorAll("a");

  toggleButton.addEventListener("click", function () {
    // トグル後の状態で判定する
    header.classList.toggle("_isOpen");
    const isOpenNow = header.classList.contains("_isOpen");

    toggleButton.setAttribute("aria-expanded", String(isOpenNow));
    navMenu.setAttribute("aria-hidden", String(!isOpenNow));

    if (isOpenNow) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  });

  // メニュー内リンククリックで閉じる
  menuLinks.forEach(link => {
    link.addEventListener("click", function () {
      if (header.classList.contains("_isOpen")) {
        header.classList.remove("_isOpen");
        toggleButton.setAttribute("aria-expanded", "false");
        navMenu.setAttribute("aria-hidden", "true");
        document.body.classList.remove("no-scroll");
      }
    });
  });

  // ウィンドウサイズ変更でモーダルを閉じる
//   let resizeTimer;
//   window.addEventListener("resize", function () {
//     clearTimeout(resizeTimer);
//     resizeTimer = setTimeout(function () {
//       if (window.innerWidth > 768) { // ←SP→PCの切り替え基準に合わせる
//         if (header.classList.contains("_isOpen")) {
//           header.classList.remove("_isOpen");
//           toggleButton.setAttribute("aria-expanded", "false");
//           navMenu.setAttribute("aria-hidden", "true");
//           document.body.classList.remove("no-scroll");
//         }
//       }
//     }, 200); // resize終了後200msで実行（ガタつき防止）
//   });
});

// JavaScriptでクリック時にクラスを切り替え
document.getElementById("hamburger").addEventListener("click", function () {
  this.classList.toggle("active");
});

window.addEventListener('scroll', function () {
  const header = document.getElementById('headerMain');
  if (window.scrollY > 100) {
    header.classList.add('hidden');
  } else {
    header.classList.remove('hidden');
  }
});

// scrollhint
document.addEventListener('DOMContentLoaded', function () {
  if (window.ScrollHint) {
    new ScrollHint('.js-scrollable', { i18n: { scrollable: '横にスクロールできます' } });
  }
});

//
// コンタクトフォームのJS
//
document.addEventListener('wpcf7mailsent', function(event) {
  location.href = 'contact/thanks/';
}, false);


// headerの切り替え
const fv = document.querySelector('.topFV');
const headerA = document.querySelector('.js-headerTop');
const headerB = document.querySelector('.js-headerMain');

function toggleHeaders(isAVisible) {
  headerA.classList.toggle('is-visible', isAVisible);
  headerB.classList.toggle('is-visible', !isAVisible);
}

// ★ FVの「下端」が画面上端より上に行ったら（= 完全に通過したら）Bを表示
function computeIsAVisible() {
  const rect = fv.getBoundingClientRect();
  return rect.bottom > 0; // 下端が0より大きい間はまだFVが残っている＝A表示
}

if (fv && headerA && headerB) {
  // IntersectionObserverはトリガー専用にし、実際の可視判定は上の関数で統一
  const io = new IntersectionObserver(() => {
    toggleHeaders(computeIsAVisible());
  }, {
    threshold: 0,
    rootMargin: '0px 0px -1px 0px' // 画面下側を1px縮めて境界の揺れを防ぐ
  });

  io.observe(fv);

  // 初期反映
  toggleHeaders(computeIsAVisible());

  // 念のためリサイズ時も更新（モバイル回転等）
  window.addEventListener('resize', () => toggleHeaders(computeIsAVisible()), { passive: true });
}

// topFVのスライダーのJS
// ===== Safari 18.4対策：全画像のload完了を待つ + レイヤー合成最適化 =====
document.addEventListener('DOMContentLoaded', function () {
  const fv = document.querySelector('.topFV');
  if (!fv) return;

  const isSP = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;

  // 保険タイムアウト - Safari 18.4では少し長めに設定
  const SAFETY_MS = parseInt(fv.dataset.safetyTimeout) || (isSP ? 2500 : 2000);

  const safetyTimer = setTimeout(() => {
    activateAnimation();
  }, SAFETY_MS);

  // アニメーション有効化処理
  function activateAnimation() {
    // Safari 18.4 flash対策: requestAnimationFrameで次のフレームで実行
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        fv.classList.add('is-ready');
      });
    });
  }

  // 全ての画像を取得（loading="eager"の画像のみ対象）
  const allImages = Array.from(fv.querySelectorAll('img[loading="eager"]'));

  if (allImages.length === 0) {
    clearTimeout(safetyTimer);
    activateAnimation();
    return;
  }

  // 既に読み込み済みの画像をフィルタリング
  const unloadedImages = allImages.filter(img => !img.complete);

  // 全画像が既に読み込み済みの場合
  if (unloadedImages.length === 0) {
    clearTimeout(safetyTimer);
    activateAnimation();
    return;
  }

  // 未読み込みの画像にload/errorイベントリスナーを設定
  const loadPromises = unloadedImages.map((img) => {
    return new Promise(resolve => {
      img.addEventListener('load', () => {
        resolve();
      });

      img.addEventListener('error', () => {
        resolve(); // エラーでも続行
      });
    });
  });

  // 全画像のload完了を待つ
  Promise.all(loadPromises).then(() => {
    clearTimeout(safetyTimer);
    activateAnimation();
  });
});



// タブ切替（タブだけ先頭固定／他の#リンクは干渉しない）
(() => {
  // -------------------------------
  // ユーティリティ
  // -------------------------------
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // 指定要素群のtransitionを一時的に無効化してから処理を実行
  const withNoTransition = (elements, run) => {
    elements.forEach(el => el.classList.add('no-transition'));
    // reflowでスタイル確定（保険）
    void document.body.offsetWidth;

    run();

    // 次フレームで復帰（DOM変更が描画に乗った後で戻す）
    requestAnimationFrame(() => {
      elements.forEach(el => el.classList.remove('no-transition'));
    });
  };

  // -------------------------------
  // タブのアクティブ化処理
  // -------------------------------
  const activateTab = (tabEl, { noTransition = false } = {}) => {
    if (!tabEl) return;
    const tabArea = tabEl.closest('.js-tab_area');
    if (!tabArea) return;

    const tabs = $$('.js-tab', tabArea);

    // パネル領域はタブ領域の直後にある .js-panel_area と想定
    const next = tabArea.nextElementSibling;
    const panelArea = next && next.classList?.contains('js-panel_area') ? next : null;
    const panels = panelArea ? $$('.js-panel', panelArea) : [];

    const idx = tabs.indexOf(tabEl);

    const run = () => {
      // タブのクラス更新
      tabs.forEach(t => t.classList.remove('is-active', '_active'));
      tabEl.classList.add('is-active', '_active');

      // パネルのクラス更新（対応indexをアクティブ）
      panels.forEach(p => p.classList.remove('is-active'));
      if (idx > -1 && panels[idx]) panels[idx].classList.add('is-active');
    };

    if (noTransition) {
      // タブボタン（::before含む）だけ止めれば十分
      withNoTransition(tabs, run);
    } else {
      run();
    }
  };

  const isTabElement = (el) => !!(el && el.classList && el.classList.contains('js-tab'));

  const activateTabByHash = (hash, { noTransition = false } = {}) => {
    const id = (hash || '').replace('#', '');
    const target = document.getElementById(id);
    if (isTabElement(target)) {
      activateTab(target, { noTransition });
      return true;
    }
    return false;
  };

  // -------------------------------
  // 初期化
  // -------------------------------
  document.addEventListener('DOMContentLoaded', () => {
    // ① タブクリック：タブ切替 → URL更新 → 先頭へ（トランジションは有効のまま）
    $$('.js-tab_area .js-tab').forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        activateTab(tab); // ← noTransitionなし＝アニメ有効
        if (tab.id) history.replaceState(null, '', `#${tab.id}`);
        window.scrollTo({ top: 0, behavior: 'auto' }); // 先頭固定
      });
    });

    // ② 初期表示（デフォルト）：各タブ領域の先頭タブをアクティブ（アニメ無効）
    $$('.js-tab_area').forEach(area => {
      const firstTab = area.querySelector('.js-tab');
      if (firstTab) activateTab(firstTab, { noTransition: true });
    });

    // ③ 初期表示：URLが“タブID(#...)”を指している場合だけ
    //    ネイティブの#スクロールを抑止して先頭固定→該当タブをアクティブ化（アニメ無効）
    if (location.hash) {
      const id = location.hash.slice(1);
      const el = document.getElementById(id);
      if (isTabElement(el)) {
        const savedId = el.id;

        // ネイティブ自動スクロール抑止のために一旦idを外す
        el.removeAttribute('id');
        window.scrollTo({ top: 0, behavior: 'auto' });

        requestAnimationFrame(() => {
          // id復帰→タブ有効化→URL維持
          el.id = savedId;
          activateTab(el, { noTransition: true });
          history.replaceState(null, '', `#${savedId}`);
        });
      }
      // ※通常のアンカー（タブでない#要素）はネイティブに任せる
    }

    // ④ 戻る/進む（hashchange）：ハッシュが“タブ”なら切替（アニメ無効 / スクロールなし）
    window.addEventListener('hashchange', () => {
      activateTabByHash(location.hash, { noTransition: true });
    });
    
  // ⑤ 追加：
    //    同一ページ内で、ヘッダー等の
    //      /interview/#interview-employee
    //      /interview/#interview-cross-talk
    //    のようなリンクをクリックしたときも
    //    「タブ切替 + ページ先頭へスクロール」にする
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]');
      if (!link) return;

      // 遷移先URLをパース
      const url = new URL(link.href, location.origin);

      // 同一パス ＆ #付きリンクでない場合は対象外
      if (url.pathname !== location.pathname || !url.hash) return;

      const id = url.hash.slice(1);
      const targetTab = document.getElementById(id);

      // そのidが「タブボタン」でない場合は何もしない
      // → 通常のページ内リンク(#sectionなど)には干渉しない
      if (!isTabElement(targetTab)) return;

      // デフォルトのアンカー挙動（途中までスクロール）を止める
      e.preventDefault();

      // タブ切替（アニメ有効）
      activateTab(targetTab);

      // URLのハッシュだけ書き換え（履歴は増やしたくないので replaceState）
      history.replaceState(null, '', `#${id}`);

      // ページ先頭へスクロール
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
    
  });

  // -------------------------------
  // toTopボタンのフッター監視（任意機能）
  // -------------------------------
  document.addEventListener('DOMContentLoaded', () => {
    const toTop = document.querySelector('.toTop');
    const footer = document.querySelector('.footer');
    if (!toTop || !footer) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // footerが見えたら非表示、見えなくなったら表示
        toTop.classList.toggle('is-hidden', entry.isIntersecting);
      });
    });

    observer.observe(footer);
  });
})();




// toTop
document.addEventListener('DOMContentLoaded', () => {
  const toTop = document.querySelector('.toTop');
  const footer = document.querySelector('.footer');

  if (!toTop || !footer) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // footerが見えたら非表示、見えなくなったら表示
      toTop.classList.toggle('is-hidden', entry.isIntersecting);
    });
  });

  observer.observe(footer);
});